exports.typeSelector = function (path) {
    // HACK: 输出时不会输出__is6xRes，故此处hack判断
    // if (global.__is6xRes && !global.__is6xRes(path)) {
    //     return null;
    // }
    var ext = path.substr(path.lastIndexOf(".") + 1);
    var typeMap = {
        "mp3": "audio",
        "jpg": "image",
        "png": "image",
        "webp": "image",
        "json": "json",
        "fnt": "font",
        "strings": "text",
        "plist": "plist",
        "pack": "pack"
    };
    var type = typeMap[ext];
    return type;
};
exports.resourceRoot = "resource-publish";
exports.alias = {};
exports.groups = {};
exports.resources = {}